import React from 'react'
import './Events.css'
import Slider from 'react-slick'
import left from '../../assets/icons/left_arrow_red.svg'
import right from '../../assets/icons/right_arrow_red.svg'
import EventCard from './EventCard'
import Calender from '../Calender/Calender'
import { useEffect, useState } from 'react';
import client from '../../sanityClient';

export default function UpcomingEvents(props) {

    const settings = {
        dots: false,
        infinite: true,
        speed: 700,
        centerMode: true,
        centerPadding: "60px",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 1000000,
        pauseOnHover: true,
        prevArrow: <img src={left} alt="prev" className='custom-arrow' />,
        nextArrow: <img src={right} alt="next" className='custom-arrow' />,
        vertical: true,

        responsive: [
            {
                breakpoint: 1350,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    centerPadding: "150px",
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    centerPadding: "100px",
                },
            },
            {
                breakpoint: 1080,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    centerPadding: "50px",
                },
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    centerPadding: "20px",
                    arrows: false,
                },
            },
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    centerPadding: "150px",
                    arrows: false,
                },
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    centerPadding: "100px",
                    arrows: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    centerPadding: "80px",
                    arrows: false,
                },
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    centerPadding: "2px",
                    arrows: false,
                },
            },
        ]
    }

    // const events = props.events;

    const [events, setEvents] = useState([]);

    useEffect(() => {
        client.fetch(`*[_type == "event"]{
          title,
          date,
          image {
            asset -> {
              _id,
              url
            }
          },
          description,
          venue,
          past,
        }`).then((data) => setEvents(data));
    }, []);

    return (
        <div className="upcoming_events">
            <h2>Upcoming <span>Events</span></h2>
            <div className="upcoming_events_container">
                <div className="upcomings_events_slider">
                    <Slider {...settings}>
                        {events.map((event, index) => {
                            return (
                                <div key={index} className='event-slide'>
                                    <EventCard
                                        title={event.title}
                                        date={new Date(event.date).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })}
                                        venue={event.venue}
                                        image={event.image.asset.url}
                                        past={event.past}
                                    />

                                </div>
                            )
                        })}
                    </Slider>
                </div>
                <Calender />
            </div>
        </div>
    )
}
